<template>
  <div class="footer">
    <nuxt-link
      :to="$puLocalePath({ name: 'about-faq' })"
      class="account-action"
      @click="toggleAccountMenu()"
    >
      <translate class="menu-item-text">FAQ</translate>
    </nuxt-link>
    <a @click.prevent="doLogout" class="account-action">
      <translate tag="span" class="menu-item-text"> Log out </translate>
    </a>
  </div>
</template>
<script setup lang="ts">
/* eslint-disable @typescript-eslint/no-unsafe-call */

/* TODO: Add proper typing to resolve type safety warnings */

const { $isDesktop, $puLocalePath } = useNuxtApp()
const authStore = useAuthStore()
const appMenuStore = useAppMenuStore(usePinia())
const route = useRoute()

function doLogout() {
  if (route?.meta?.middleware?.includes('auth-redirect')) {
    authStore.logOut('/')
  } else {
    authStore.logOutInPlace()
  }
}

function toggleAccountMenu() {
  if (!$isDesktop) {
    appMenuStore.toggleAccountMenu()
  }
}
</script>
<style scoped>
.footer {
  padding: 1.4em;
  font-size: var(--body);
  display: flex;
  justify-content: space-between;
  align-items: center;
  bottom: 0;
  top: auto;
  margin: auto 0 0 0;
  display: flex;
  gap: 1em;
}

a {
  text-decoration: none;
}

.account-action {
  font-size: var(--title);
}
</style>
